var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4911 21.4552L0.366101 13.3302C-0.122034 12.8421 -0.122034 12.0506 0.366101 11.5625L2.13383 9.79469C2.62196 9.30651 3.41346 9.30651 3.9016 9.79469L9.37499 15.268L21.0984 3.54469C21.5865 3.05656 22.378 3.05656 22.8662 3.54469L24.6339 5.31246C25.122 5.8006 25.122 6.59205 24.6339 7.08024L10.2589 21.4553C9.77069 21.9434 8.97924 21.9434 8.4911 21.4552Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.9928de2c1403c2d3a3ea5cf5801a6271.svg";
export { ForwardRef as ReactComponent };